<template>
    <a :href="'https://www.google.com.br/maps/place/' + lat + ',' + long + '/@' + lat + ',' + long + ',17.79z'"
       target="_blank" style="padding-right: 10px">
        <img src="/assets/img/google-maps.png" style="height: 30px">
    </a>
</template>

<script>
export default {
    name: "GoogleMapsButton",
    props: {
        lat: {
            required: true
        },
        long: {
            required: true
        }
    }
}
</script>

<style scoped>

</style>
